import { render, staticRenderFns } from "./childAccountManage.vue?vue&type=template&id=6cc6cfca&scoped=true"
import script from "./childAccountManage.vue?vue&type=script&lang=js"
export * from "./childAccountManage.vue?vue&type=script&lang=js"
import style0 from "./childAccountManage.vue?vue&type=style&index=0&id=6cc6cfca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc6cfca",
  null
  
)

export default component.exports